import TransactionTypeBox from "../../shared/TransactionTypeBox";
import { tdpDetails } from "../../../../shared/HOCs/withRedux";
import { TRANSACTION_TYPE } from "../../../../shared/reduxRoutes/tdpDetailsRoutes";

export default tdpDetails({
  WrappedComponent: TransactionTypeBox,
  states: TRANSACTION_TYPE,
});
